// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatWorkflowSkillReferenceDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatWorkflowStatus } from "./chat-workflow-status.enum.gen";

export const ChatWorkflowSkillReferenceDtoGenShape = z.strictObject({
  workflowId: z.string(),
  documentId: z.string(),
  name: z.string(),
  versionLabel: z.string().optional(),
  status: z.enum(ChatWorkflowStatus),
});
